module.exports = __webpack_public_path__ + "static/woman-dd7efdeca36a6003add2e5d9e296831c.png";